import React from 'react';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';

// Modal genérico de comparação (Comparar Áreas / Comparar Polos) — EXCLUSIVO do MapBox,
// em PrimeReact. Equivalente aos ModalCompareArea/ModalComparePolosGeradores do mapa
// Google (react-bootstrap + react-select, que ficam intactos). `onCompare(values)` faz o
// download; o modal cuida da seleção e do estado de carregamento.
const CompareModal = ({ visible, onHide, title, options, onCompare }) => {
    const [selected, setSelected] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const submit = async () => {
        if (selected.length < 2) return;
        setLoading(true);
        try {
            await onCompare(selected);
            setSelected([]);
            onHide();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            header={title}
            visible={visible}
            onHide={() => { setSelected([]); onHide(); }}
            style={{ width: '30rem', maxWidth: '95vw' }}
            dismissableMask
        >
            <p className="mb-2">Selecione as áreas que quer comparar</p>
            <MultiSelect
                value={selected}
                onChange={(e) => setSelected(e.value)}
                options={options}
                appendTo={document.body}
                optionLabel="label"
                display="chip"
                placeholder="Selecione as áreas"
                className="w-100"
                disabled={loading}
            />
            <button
                type="button"
                className="btn btn-primary btn-block mt-3"
                onClick={submit}
                disabled={loading || selected.length < 2}
                title={selected.length < 2 ? 'Selecione ao menos duas áreas' : 'Comparar'}
            >
                {loading
                    ? <><i className="fa fa-spin fa-spinner mr-1"></i> Gerando…</>
                    : 'Comparar'}
            </button>
        </Dialog>
    );
};

export default CompareModal;
